<template>
	<transition name="scroll">
		<div
			v-if="scrollY < 30"
			class="iv2-home__scroll-bar theme-a__scroll position-fixed d-none d-xl-block"
			@click="scroll"
		>
			<span class="iv2-home__scroll-bar-text">{{ $t('general.scroll') }}</span>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			scrollY: 0,
		};
	},

	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll() {
			this.scrollY = window.scrollY;
		},

		scroll: function () {
			var height = window.innerHeight;
			window.scrollTo({
				top: height,
				behavior: "smooth",
			});
		},
	},
};
</script>

<style lang="scss">
.iv2-home__scroll-bar {
	left: 30px;
	bottom: 133px;
	-webkit-transform: rotate(90deg);
	transform: rotate(90deg);
	font-size: 10px;
	font-weight: 400;
	letter-spacing: 0.3em;
	cursor: pointer;
	z-index: 5;

	&::after {
		content: "";
		width: 60px;
		position: absolute;
		left: 65px;
		top: 50%;
	}

	&.scroll-enter-active,
	&.scroll-leave-active {
		transition: all 1s ease;
	}

	&.scroll-enter,
	&.scroll-leave-to {
		transform: rotate(90deg) translateX(-50px) !important;
		opacity: 0;
	}
}
</style>